import { render, staticRenderFns } from "./ModuleTrendingTokens.vue?vue&type=template&id=047f2054&scoped=true"
import script from "./ModuleTrendingTokens.vue?vue&type=script&lang=js"
export * from "./ModuleTrendingTokens.vue?vue&type=script&lang=js"
import style0 from "./ModuleTrendingTokens.vue?vue&type=style&index=0&id=047f2054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047f2054",
  null
  
)

export default component.exports